const lifeYellRoutes = [
  {
    // TOP
    path: "/",
    name: "CrlyTop",
  },
  {
    // 会員登録
    path: "/",
    name: "CrlySignUp",
  },
  {
    // FAQ
    path: "/faq",
    name: "CrlyFAQ"
  },
  {
    // 利用ガイド
    path: "/guide",
    name: "CrlyGuide"
  },
  {
    // お知らせ
    path: "/news",
    name: "CrlyNews"
  },
  {
    // お知らせ詳細
    path: "/newsDetail/:id",
    name: "CrlyNewsDetail",
  },
  {
    // 加入状況
    path: "/memberStatus",
    name: "CrlyMemberStatus"
  },
  {
    // ライフエールとは
    path: "/promotion",
    name: "CrlyPromotion"
  },  
  {
    // お気に入り一覧
    path: "/favorite",
    name: "CrlyFavorite"
  },
  {
    // お気に入り一覧
    path: "/favorite",
    name: "CrlyFavorite"
  },
  {
    // ご意見箱
    path: "/opinion",
    name: "CrlyOpinionBox",
  },
  // ----------------------------
  // カテゴリナビバーからの遷移先 ↓
  // ----------------------------
  {
    path: "/leisure",
    name: "CrlyLeisure"
  },
  {
    path: "/gourmet",
    name: "CrlyGourmet"
  },
  {
    path: "/childcare",
    name: "CrlyChildcare"
  },
  {
    path: "/shopping",
    name: "CrlyShopping"
  },
  {
    path: "/relaxation",
    name: "CrlyRelaxation"
  },
  {
    path: "/sports",
    name: "CrlySports"
  },
  {
    path: "/travel",
    name: "CrlyTravel"
  },
  {
    path: "/car",
    name: "CrlyCar"
  },
  {
    path: "/original",
    name: "CrlyOriginal"
  },
  {
    path: "/school",
    name: "CrlySchool"
  },
  {
    path: "/life",
    name: "CrlyLife"
  },
  // ----------------------------
  // ----------------------------

  // error系
  {
    path: "/404",
    name: "CrlyError404",
    meta: {
      error: 404
    }
  },
  {
    path: "/session-time-out",
    name: "CrlySessionTimeOut",
    meta: {
      error: "session"
    }
  },
  {
    path: "/*",
    redirect: { name: "CrlyError404" }
  }
];

for (var i = 0; i < lifeYellRoutes.length; i++) {
  lifeYellRoutes[i].beforeEnter = (to) => {
    window.location.href = process.env.VUE_APP_TOP_DOMAIN + to.path;
  };
}

export default lifeYellRoutes;
